export default "__VITE_ASSET__Bgvj6mLQ__"